var KB = 1024;
var MB = 1024 * 1024;
var oneDecimal = new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 1 });
/**
 * Human-readable file size in Czech notation: bytes below 1 kB, whole kB
 * below 1 MB, MB with at most one decimal (cs-CZ: "1,5 MB") above.
 */
export var formatFileSize = function (bytes) {
    if (bytes < KB)
        return "".concat(bytes, " B");
    if (bytes < MB)
        return "".concat(Math.round(bytes / KB), " kB");
    return "".concat(oneDecimal.format(bytes / MB), " MB");
};
